import { useContext } from 'react';
import PaginationOffsetContext from 'contexts/PaginationOffset/PaginationOffsetContext';

export default function usePaginationOffset() {
    const { paginationOffset } = useContext(PaginationOffsetContext);

    return [paginationOffset];
}
